import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";

export default function SizeTable() {
  return (
    <div className="add-address-container body-container default is-ctl-home-page is-ctl-landingpage is-ctl-navigation is-act-home">
      
      <div className="min-h-screen flex flex-col items-center justify-center p-6 bg-gray-100">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-4xl w-full">
          <div style={{ padding: "35px" }}>
            <h2 className="text-3xl font-bold mb-4 text-center middle1" style={{color:"black",fontWeight:"bold"}}>
              Men's Tops (Asian Sizing)
            </h2>
            <p className="mb-4 text-center text-gray-600 small1">
              The measurements on the size chart are body measurements. Find
              your correct size in the chart below. Scroll horizontally to see
              more sizes.
            </p>
            <div className="overflow-x-auto mt-4">
              <table className="w-full border-collapse border border-gray-300 text-center">
                <thead>
                  <tr className="bg-gray-200">
                    <th className="border border-gray-300 px-4 py-2">Size</th>
                    <th className="border border-gray-300 px-4 py-2">XXS</th>
                    <th className="border border-gray-300 px-4 py-2">XS</th>
                    <th className="border border-gray-300 px-4 py-2">S</th>
                    <th className="border border-gray-300 px-4 py-2">M</th>
                    <th className="border border-gray-300 px-4 py-2">L</th>
                    <th className="border border-gray-300 px-4 py-2">XL</th>
                    <th className="border border-gray-300 px-4 py-2">2XL</th>
                    <th className="border border-gray-300 px-4 py-2">3XL</th>
                    <th className="border border-gray-300 px-4 py-2">4XL</th>
                    <th className="border border-gray-300 px-4 py-2">5XL</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border border-gray-300 px-4 py-2">
                      Chest (cm)
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      &lt; 79
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      79 - 85
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      85 - 91
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      91 - 97
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      97 - 103
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      103 - 109
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      109 - 116
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      116 - 124
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      124 - 130
                    </td>
                    <td className="border border-gray-300 px-4 py-2">130+</td>
                  </tr>
                  <tr>
                    <td className="border border-gray-300 px-4 py-2">
                      Waist (cm)
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      &lt; 67
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      67 - 73
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      73 - 79
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      79 - 85
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      85 - 91
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      91 - 97
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      97 - 104
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      104 - 112
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      112 - 120
                    </td>
                    <td className="border border-gray-300 px-4 py-2">120+</td>
                  </tr>
                  <tr>
                    <td className="border border-gray-300 px-4 py-2">
                      Hip (cm)
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      &lt; 81.5
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      81.5 - 86.5
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      86.5 - 91.5
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      91.5 - 96.5
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      96.5 - 101.5
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      101.5 - 106.5
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      106.5 - 112
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      112 - 118
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      118 - 123
                    </td>
                    <td className="border border-gray-300 px-4 py-2">123+</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="mt-6">
              <h3 className="text-xl font-semibold" style={{color:"black"}}>Fit Tips</h3>
              <p className="text-gray-600 small1">
                If you're on the borderline between two sizes, order the smaller
                size for a tighter fit or the larger size for a looser fit. If
                your measurements for chest and waist correspond to two
                different suggested sizes, order the size indicated by your
                chest measurement.
              </p>
              <h3 className="text-xl font-semibold mt-4" style={{color:"black"}}>How To Measure</h3>
              <ul className="text-gray-600 list-disc pl-6 small1">
                <li>
                  <strong>CHEST:</strong> Measure around the fullest part of
                  your chest, keeping the measuring tape horizontal.
                </li>
                <li>
                  <strong>WAIST:</strong> Measure around the narrowest part
                  (typically where your body bends side to side), keeping the
                  tape horizontal.
                </li>
                <li>
                  <strong>HIPS:</strong> Measure around the fullest part of your
                  hips, keeping the tape horizontal.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
